import { RouteRecordRaw } from "vue-router";

export const auth: RouteRecordRaw = {
  path: "/auth",
  component: () =>
    import(/* webpackChunkName: "auth" */ "@/layouts/Default.vue"),
  children: [
    {
      path: "welcome",
      name: "Welcome",
      component: () =>
        import(/* webpackChunkName: "auth" */ "@/views/auth/Welcome.vue"),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "register-or-login",
      name: "RegisterOrLogin",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/RegisterOrLogin.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "login",
      name: "Login",
      component: () =>
        import(/* webpackChunkName: "auth" */ "@/views/auth/Login.vue"),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "phone-number-auth",
      name: "RegisterPhoneNumberAuth",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/RegisterPhoneNumberAuth.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "edit-phone-number-auth",
      name: "EditPhoneNumberAuth",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/EditPhoneNumberAuth.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "password-setting",
      name: "PasswordSetting",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/PasswordSetting.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "v1-user-phone-number-auth",
      name: "V1UserPhoneNumberAuth",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/V1UserPhoneNumberAuth.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "v1-user-auth-completed",
      name: "V1UserAuthCompleted",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/V1UserAuthCompleted.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "v1-user-account-auth",
      name: "V1UserAccountAuth",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/V1UserAccountAuth.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "reset-password-after-login",
      name: "ResetPasswordAfterLogin",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/ResetPasswordAfterLogin.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "reset-password-before-login",
      name: "ResetPasswordBeforeLogin",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/ResetPasswordBeforeLogin.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "reset-password-account-auth",
      name: "ResetPasswordAccountAuth",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/ResetPasswordAccountAuth.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    },
    {
      path: "reset-password-setting",
      name: "ResetPasswordSetting",
      component: () =>
        import(
          /* webpackChunkName: "auth" */ "@/views/auth/ResetPasswordSetting.vue"
        ),
      meta: {
        isBeforeLogin: true
      }
    }
  ]
};
